import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Breadcrumb from '../../components/common/Breadcrumb';
import './Orders.scss';

const Orders = () => {
  const navigate = useNavigate();
  const location = useLocation(); // 현재 경로 정보를 가져옴

  // 경로 일치 여부를 확인하는 함수
  const isActive = (path) => (location.pathname === path ? 'active' : '');

  return (
    <div className="sub-page orders-page">
      <section className="sub-visual orders">
        <div className="container">
          <span className="sub-title">ORDER SYSTEM</span>
          <h1>발주관리</h1>
          <p>온라인 발주 시스템을 통해 간편하게 주문하고 관리하실 수 있습니다.</p>
        </div>
      </section>

      <Breadcrumb />

      <nav className="category-nav">
        <div className="container">
          <div className="nav-inner">
            <button className={isActive('/community/notice')} onClick={() => navigate('/community/notice')}>
              공지사항
            </button>
            <button className={isActive('/community/orders')} onClick={() => navigate('/community/orders')}>
              발주관리(준비중)
            </button>
            <button className={isActive('/community/cert')} onClick={() => navigate('/community/cert')}>
              인증서 및 성적서
            </button>
          </div>
        </div>
      </nav>

      <div className="container content-wrap">
        <div className="preparing-box">
          <div className="icon-ani">
            <span className="icon">📄</span>
            <span className="truck">🚚</span>
          </div>
          <h2>서비스 준비 중입니다</h2>
          <p className="main-desc">
            더 빠르고 간편한 발주 경험을 위해 <br />
            <strong>온라인 발주 시스템을 구축</strong>하고 있습니다.
          </p>
          <div className="sub-desc">
            <p>조금만 기다려 주시면 최적화된 물류 솔루션으로 찾아뵙겠습니다.</p>
            <p>
              발주 관련 문의는 대표번호 <strong>031-366-0666</strong>으로 연락 바랍니다.
            </p>
          </div>

          <button className="btn-back" onClick={() => navigate('/')}>
            메인페이지로 이동
          </button>
        </div>
      </div>
    </div>
  );
};

export default Orders;
